//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { parseDateYYYYMMDD, formatDateDDMMYYYY } from '../../common/functions/date-utils';
import { buscaAutocomplete, triggerSelecao } from '../../common/functions/autocomplete-utils';
import Confirm from '../../shared-components/vuetify/dialog/Confirm';
import Editor from '../../shared-components/editor/Editor';

export default {
  name: 'TermoAceiteForm',
  components: {
    Confirm,
    Editor,
  },
  props: {
    somenteLeitura: { type: Boolean, default: false },
    criarNovoTermoAceite: { type: Boolean },
  },
  data() {
    return {
      extensaoResources: this.$api.extensao(this.$resource),
      termoAceiteResources: this.$api.termoAceite(this.$resource),

      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
        validDate: value => (!value || (value.length === 10 && this.moment(value, 'DD-MM-YYYY').isValid())) || this.$t('message.data_invalida'),
      },
      objetivos: [
        { text: this.$t('label.primeiro_acesso'), value: 'PRIMEIRO_ACESSO' },
        { text: this.$t('label.revalidacao'), value: 'REVALIDACAO' },
      ],
      objetivosSemRevalidacao: [
        { text: this.$t('label.primeiro_acesso'), value: 'PRIMEIRO_ACESSO' },
      ],
      frequencias: [
        { text: this.$t('label.sempre'), value: 'SEMPRE' },
        { text: this.$t('label.unica_vez'), value: 'UNICA_VEZ' },
      ],
      tiposUsuario: [
        { text: this.$tc('label.fornecedor', 1), value: 'FORNECEDOR' },
        { text: this.$tc('label.cliente', 1), value: 'CLIENTE' },
      ],
      termo: {
        descricao: '',
        objetivo: undefined,
        frequencia: undefined,
        unidades: [],
        gruposFornecedor: [],
        tipoUsuario: undefined,
        conteudo: '',
      },
      menuDataInicio: false,
      dataInicio: '',
      unidades: [],
      gruposFornecedor: [],
      triggerGrupoFornecedor: null,
      timeoutTrigger: null,
    };
  },
  watch: {
    triggerGrupoFornecedor(val) {
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(() => {
        if (val != null) this.buscarGruposFornecedores(val);
      }, 500);
    },
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    ...mapGetters('implantacao', [
      'indModoVarejo',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el.startsWith('TERMO_ACEITE')).length;
    },
    dateInicioFormatada: {
      get() {
        return formatDateDDMMYYYY(this.dataInicio);
      },
      set(newValue) {
        this.dataInicio = parseDateYYYYMMDD(newValue);
      },
    },
  },
  methods: {
    buscaAutocomplete,
    triggerSelecao,
    accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
    },
    buscarUnidades() {
      const value = {
        tamanhoPagina: 1000,
        idNivelExtensao: 1,
      };
      return this.extensaoResources.listarPorUsuario(value).then((resultado) => {
        this.unidades = resultado.data.resposta;
      });
    },
    buscarGruposFornecedores(filtro = null) {
      const value = {
        tamanhoPagina: 5000,
        idNivelExtensao: 3,
        nome: filtro,
      };
      return this.extensaoResources.listarAtivos(value).then((resultado) => {
        this.gruposFornecedor = resultado.data.resposta;
      });
    },
    abrirDialogSalvar() {
      if (!this.$refs.form.validate()) return;
      const texto = this.$refs.editor.getTexto();
      if (!texto || texto === '' || texto === ' ') {
        this.$toast.create(this.$t('message.insira_conteudo'), 'snack', 3E3);
        return;
      }
      this.$refs.confirmDialog.open();
    },
    salvar() {
      this.$refs.confirmDialog.close();
      this.termo.idsExtensoes = [];
      if (this.indModoVarejo) {
        this.termo.idsExtensoes = this.termo.idsExtensoes
          .concat(this.termo.gruposFornecedor.map(el => el.id));
      } else {
        this.termo.idsExtensoes = this.termo.idsExtensoes
          .concat(this.termo.unidades.map(el => el.id));
      }
      this.termo.dataInicio = this.dataInicio;
      this.termo.conteudo = this.$refs.editor.getTexto();

      if (this.termo.id) {
        this.termoAceiteResources.atualizar(this.termo)
          .then(() => {
            this.$router.push({ name: 'termo-aceite' });
            this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
          })
          .catch((err) => {
            this.$toast.create(err.data.error, 'snack', 3E3);
          });
      } else {
        this.termoAceiteResources.gravar(this.termo)
          .then(() => {
            this.$router.push({ name: 'termo-aceite' });
            this.$toast.create(this.$t('message.adicionado_confira_tabela'), 'snack', 3E3);
          })
          .catch((err) => {
            this.$toast.create(err.data.error, 'snack', 3E3);
          });
      }
    },
    cancelar() {
      this.$router.push({ name: 'termo-aceite' });
    },
    carregarTermo(id) {
      this.termoAceiteResources.buscar({ id })
        .then((res) => {
          this.termo = Object.assign({}, this.termo, res.body);
          this.dataInicio = this.termo.dataInicio;
          if (this.indModoVarejo) {
            this.termo.gruposFornecedor = [];
            if (this.termo.idsExtensoes && this.termo.idsExtensoes.length) {
              this.gruposFornecedor.forEach((gf) => {
                if (this.termo.idsExtensoes.indexOf(gf.id) !== -1) {
                  this.termo.gruposFornecedor.push(gf);
                }
              });
            }
          } else {
            this.termo.unidades = [];
            this.unidades.forEach((u) => {
              if (this.termo.idsExtensoes.indexOf(u.id) !== -1) {
                this.termo.unidades.push(u);
              }
            });
          }
          window.setTimeout(() => {
            this.$refs.editor.setTexto(this.termo.conteudo);
          }, 1000);
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  mounted() {
    if (this.indModoVarejo) {
      this.termo.tipoUsuario = 'FORNECEDOR';
      this.termo.objetivo = 'PRIMEIRO_ACESSO';
      this.buscarGruposFornecedores().then(() => {
        const id = this.$route.params.id;
        if (id) {
          this.carregarTermo(id);
        }
      });
    } else {
      this.termo.tipoUsuario = 'CLIENTE';
      this.termo.objetivo = 'PRIMEIRO_ACESSO';
      this.buscarUnidades().then(() => {
        const id = this.$route.params.id;
        if (id) {
          this.carregarTermo(id);
        }
      });
    }
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/spa/termo-aceite/TermoAceiteForm.vue?vue&type=script&lang=js&